import { BaseEntity } from '@/api/EntityApi';

export enum UserStatus {
	INACTIVE = 'inactive',
	ACTIVE = 'active',
	SUSPENDED = 'suspended',
}

export enum UserType {
	ADMIN = 'admin',
	USER = 'user',
}

interface BaseUser extends BaseEntity {
	firstName: string;
	lastName: string;
	email: string;
	password: string;
	status: UserStatus;
	userType: UserType;
}

export interface User extends BaseUser {
	phoneNumber: string;
	street: string;
	postalCode: string;
	city: string;
	userType: UserType.USER;
}

export type AppUser = User;
